//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';
/* import { NotificationManager } from 'Components/Notifications'; */
import axios from 'axios';

//Action types
import { REALTIME_MAP_GET_KMLS, REALTIME_MAP_UPDATE_KMLS } from 'Redux/actionTypes';

//actions
import { getKmlsConfirmResult, 
    updateKmlsConfirmResult, 
    getLandmarksAndGeofences as getKmls,
    getJsonLandmarkConfirmResult,
    getJsonGeofenceConfirmResult
 } from 'Redux/actions';


//Function
function* updateJsonFilesRequest({ payload }) {
	try {
		let data = yield call(
			clientMutation,
			`mutation updateJsonMapFiles ($id: Int, $generatedFile: Int!, $entityName: JsonMapEntityName) {
                updateJsonMapFiles (id: $id, generatedFile: $generatedFile, entityName: $entityName) {
                    id
                    companyId
                    entityName
                    fileIndex
                    jsonPath
                    generatedFile
                    generatedAt
                    changedAt
                }
            }`,
			{ 
        generatedFile: 0
      },
			endpoints.GRAPHQL_GENERAL,
		);
		if (data && data.updateJsonMapFiles) {
			yield put(updateKmlsConfirmResult(data.updateJsonMapFiles));
            yield put(getKmls())
		} else {
			throw "Error clearing Landmark Group";
		}
	} catch (exc) {
		// ALWAYS RETURN ACTION
		ExceptionManager(exc, 'modules/realtimeMaps/views/redux/saga', 'updateJsonFilesRequest');
		yield put(updateKmlsConfirmResult(false, exc.errorData));
    //NotificationManager.error('Error', `Error Delete Landmark Group`, 3000, null, null, 'error');
	}
}

function* watchGetKmlsTasksRequest() {
    yield takeEvery(REALTIME_MAP_UPDATE_KMLS, updateJsonFilesRequest);
}

//Saga Export
export default function* rootSaga() {
	yield all([
		fork(watchGetKmlsTasksRequest)
	]);
}

